module.exports = __webpack_public_path__ + "assets/img/Frame.5fee2a05.svg";